<template>
    <div>
        <div class="topimage">
            <el-image style="width:100%"
                :src="require('@/assets/jishu/banner' + (this.$i18n.locale == 'zh' ? '' : '_' + this.$i18n.locale) + '.jpg')"></el-image>
        </div>
        <div class="appmain">
            <div class="itemgrid">
                <div class="item" v-if="$i18n.locale != 'en' && $i18n.locale != 'tr'" @click="nav('datadownload')">
                    <div class="jsimage">
                        <el-image :src="require('@/assets/jishu/ziliao.png')"></el-image>
                    </div>
                    <div class="jstitle">{{ $t('layout.download') }}</div>
                </div>
                <div class="item" @click="nav('productcatalogue')">
                    <div class="jsimage">
                        <el-image :src="require('@/assets/jishu/xuanxing.png')"></el-image>
                    </div>
                    <div class="jstitle">{{ $t('layout.model') }}</div>
                </div>
                <div class="item" @click="nav('ecucode')">
                    <div class="jsimage">
                        <el-image :src="require('@/assets/jishu/ecu.png')"></el-image>
                    </div>
                    <div class="jstitle">{{ $t('layout.ECUfaultcode') }}</div>
                </div>
                <div class="item" @click="nav('faqs')">
                    <div class="jsimage">
                        <el-image :src="require('@/assets/jishu/wenti.png')"></el-image>
                    </div>
                    <div class="jstitle">{{ $t('layout.FAQ') }}</div>
                </div>
                <div class="item" @click="nav('feedback')">
                    <div class="jsimage">
                        <el-image :src="require('@/assets/jishu/fankui.png')"></el-image>
                    </div>
                    <div class="jstitle">{{ $t('layout.Productfeedback') }}</div>
                </div>
                <div class="item" @click="openCompare">
                    <div class="jsimage">
                        <el-image :src="require('@/assets/jishu/ziliao.png')"></el-image>
                    </div>
                    <div class="jstitle">{{ $t('layout.ParameterComparison') }}</div>
                </div>
            </div>
        </div>
        <el-dialog custom-class="compare-dialog" :title="$t('layout.ParameterComparison')"
            :visible.sync="compareVisible" width="420px" :close-on-click-modal="false">
            <el-cascader v-model="compareCatId" style="width:100%" filterable clearable :options="compareCascadeOptions"
                :props="cascadeProps" :placeholder="$t('all')"></el-cascader>
            <div slot="footer">
                <el-button @click="compareVisible = false">{{ $t('close') }}</el-button>
                <el-button type="primary" :loading="compareLoading" @click="downloadCompare">{{ $t('download')
                }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { productsClass } from '@/api/api'
    export default {
        data() {
            return {
                title: '',
                compareVisible: false,
                compareCatId: '',
                compareLoading: false,
                classList: [],
                cascadeProps: {
                    checkStrictly: true,
                    emitPath: false
                }
            }
        },
        created() {
            this.title = this.$t('layout.technical') + '-' + this.$t('seo.title')
        },
        computed: {
            compareCascadeOptions() {
                let all = { value: '', label: this.$t('all') }
                let arr = this.classList.map(item => ({
                    value: item.cat_id,
                    label: item.cat_name,
                    children: (item.children || []).map(sub => ({
                        value: sub.cat_id,
                        label: sub.cat_name
                    }))
                }))
                return [all, ...arr]
            }
        },
        metaInfo() {
            return {
                title: this.title,
                meta: [
                    {
                        name: 'keyWords',
                        content: this.$t('seo.keywords')
                    },
                    {
                        name: 'description',
                        content: this.$t('seo.description')
                    }
                ]
            }
        },
        methods: {
            nav(item) {
                this.$router.push('/' + item, '_blank')
            },
            openCompare() {
                this.compareCatId = ''
                this.compareVisible = true
                if (this.classList.length == 0) {
                    productsClass().then(res => {
                        this.classList = res.data
                    })
                }
            },
            downloadCompare() {
                this.compareLoading = true
                const params = new URLSearchParams({ lang: this.$i18n.locale })
                if (this.compareCatId) {
                    params.set('cat_id', this.compareCatId)
                }
                const url = process.env.VUE_APP_BASE_API + 'web/productParameters/pdf?' + params.toString()
                window.open(url)
                this.compareVisible = false
                this.compareLoading = false
            }
        }
    }
</script>
<style lang="scss" scoped>
    .appmain {
        width: 60%;
        margin: 0 auto;
    }

    .itemgrid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;
        padding: 20px 0;
    }

    @media screen and (max-width: 480px) {
        .appmain {
            width: 100%;
        }

        .itemgrid {
            grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
            gap: 12px;
            padding: 12px;
        }
    }

    .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 242px;
        cursor: pointer;
        background: #fff;

        .jsimage {
            width: 70px;
            height: 70px;
            margin: 0 auto;
        }

        .jstitle {
            margin-top: 15px;
            text-align: center;
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
            color: #333333;
        }
    }
</style>
<style lang="scss">
    /* 产品参数对比弹窗：头部与按钮使用站点主色 #0052D9 */

    .compare-dialog .el-dialog__footer .el-button--primary {
        background: #0052D9;
        border-color: #0052D9;
    }

    .compare-dialog .el-dialog__footer .el-button--primary:hover,
    .compare-dialog .el-dialog__footer .el-button--primary:focus {
        background: #3D6FD9;
        border-color: #3D6FD9;
    }
</style>
